import PropTypes from "prop-types";
import React, { useContext } from "react";
import logo from "../images/logo-engie-blue.svg";
import { Link } from "./link";
import ThemeSwitch from "./elements/theme-switch";
import AppContext from "../context/app-context";
import PreviewBar from "./preview-bar";

const HeaderSmall = ({ siteTitle = "" }) => {
  const { darkMode, setDarkMode } = useContext(AppContext);

  return (
    <div className="header">
      <div className="nj-header nj-header--fixed">
        <div className="nj-header__group">
          {process.env.NODE_ENV === "development" && <PreviewBar />}
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="header__top d-flex align-items-center">
                  <div className="row w-100 mx-0">
                    <div className="col-4 d-inline-flex align-items-center pl-0">
                      {/* <Link to="/" checkActive={checkActive} localized={false}
                        activeClassName="header__link--active" className="header__link mr-1">IT</Link>
                      <Link to="/en/" checkActive={checkActive} activeClassName="header__link--active" className="header__link">EN</Link> */}
                      <ThemeSwitch
                        className=""
                        checked={darkMode}
                        setChecked={setDarkMode}
                      />
                    </div>
                    <div className="col-4 header__logo text-center">
                      <Link className="header__link h-100" to="/">
                        <img src={logo} className="h-100" alt={siteTitle} />
                      </Link>
                    </div>
                    <div className="col-4 d-inline-flex justify-content-end align-items-center pr-0"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

HeaderSmall.propTypes = {
  siteTitle: PropTypes.string,
};

export default HeaderSmall;
